  import React from 'react'
  import { useCourseProposals } from './UseCourseProposals'
  import TeachrCard from './TeachrCard';
  import { useState } from 'react';
  import { Button } from 'react-bootstrap';
  import ClientDialogLayout from './ClientDialogLayout';
  interface Props {
    punctualId: number;
    clientId?: number;
    toggleRow: (id: number) => void;
    activeRow: number | null;
    load: boolean;
    setLoad: React.Dispatch<React.SetStateAction<boolean>>;
    isHome?: boolean;
    onOpenProposal?: () => void;
    clientID?: number;
    duration?: number;
    activeTab?: string;
  }

  interface CourseProposal {
    id: number;
    teacherName: string;
    startDatetime: string;
    endDatetime: string;
    description?: string;
    isRemote: boolean;
    isCourseInTheHour: boolean;
    duration?: number;
    creationDatetime?: Date;
    priceRate: number;
    finalTotal: number;
    averageNote: any;
    teacherId: number | undefined;
    isAccepted: boolean;
    isRefused: boolean;
    clientID?: number;
  }

  const ConsultationDesCours = ({ punctualId, load, setLoad, onOpenProposal, duration, activeTab}: Props) => {
    const proposals = useCourseProposals(punctualId, load, setLoad);

    const [openProposal, setOpenProposal] = useState<CourseProposal | null>(null);
    
      // const handleShowDetail = (proposal: CourseProposal) => setOpenProposal(proposal);
      const handleShowDetail = (proposal: CourseProposal) => {
        setOpenProposal(proposal);
        if (onOpenProposal) onOpenProposal(); // close detail dialog
      };
      const handleCloseShowDetail = () => setOpenProposal(null);
    
    return (
      <div className="flex flex-col gap-4 ">
        {proposals.map((proposal) => (
          <Button
            onClick={() => handleShowDetail(proposal)}
            className="px-2 py-1 text-sm border rounded-md bg-[#4077B6] text-white hover:bg-[#305f8e]"
          >
            Proposal de {proposal.teacherName} prof de {}
          </Button>
        ))}

        {openProposal && (
          <ClientDialogLayout
            title="Détails du cours"
            text={""}
            open
            handleClose={handleCloseShowDetail}
            handleCloseIcon={handleCloseShowDetail}
          >
            {/* <TeachrCard openProposal={openProposal} /> */}
            <TeachrCard
              openProposal={{
                ...openProposal,
                teachrId: openProposal.teacherId!,
                isAccepted: openProposal.isAccepted ?? false,
                isRefused: openProposal.isRefused ?? false,
              }}
              duration={duration}
              activeTab={activeTab}
            />
          </ClientDialogLayout>
        )}
      </div>
    );
  }

  export default ConsultationDesCours;